import React, { Component } from "react";
import PropTypes from "prop-types";
import { withFormsy } from "formsy-react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

class CustomDatePicker extends Component {
  handleChange = (date) => {
    if (date) {
      this.props.onChange(date, this.props.name);
    }
  };

  render() {
    let { name, placeholderText, value, label, required, disabled } =
      this.props;

    name = name.replace(/_/g, " ");
    const fieldLabel = required && !disabled ? (label += " *") : label;
    const errorMessage = this.props.getErrorMessage();

    return (
      <div className="form-group row">
        <label
          className="control-label"
          htmlFor={name}
          style={{ textTransform: "uppercase" }}
        >
          {fieldLabel}
        </label>
        <DatePicker
          name={name}
          selected={value ? moment(value) : null}
          className="form-control"
          onChange={this.handleChange}
          placeholderText={placeholderText || "Enter date"}
          disabled={disabled}
          autoComplete="off"
        />
        <span className="validation-message">{errorMessage}</span>
      </div>
    );
  }
}

CustomDatePicker.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholderText: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func,
  required: PropTypes.bool,
  getErrorMessage: PropTypes.func
};

export default withFormsy(CustomDatePicker);
